"use strict";

var list=[
  {
    "key": "国内热门目的地",
    "from": 1,
    "type": 0,
    "value": [
      {
        "key": "香港",
        "id": "3201",
        "value": [
          22783,
          389153,
          22762,
          22755,
          22658,
          392162
        ]
      },
      {
        "key": "澳门",
        "id": "3301",
        "value": [
          65791,
          24854,
          391825,
          23603,
          23411,
          316986
        ]
      },
      {
        "key": "北京",
        "id":"0101",
        "value": [
          26797,
          45128,
          45138,
          1574,
          24121,
          1257
        ]
      },
      {
        "key": "上海",
        "id": "0201",
        "value": [
          3134,
          3059,
          391889,
          399345,
          2809,
          2894
        ]
      },
      {
        "key": "广州",
        "id": "2001",
        "value": [
          26952,
          16551,
          392288,
          16509,
          26730,
          16069
        ]
      },
      {
        "key": "深圳",
        "id": "2003",
        "value": [
          82205,
          399167,
          23384,
          16961,
          23113,
          387265
        ]
      },
      {
        "key": "三亚",
        "id": "2201",
        "value": [
          19049,
          18947,
          23417,
          79160,
          25732,
          19088
        ]
      },
      {
        "key": "杭州",
        "id": "1201",
        "value": [
          9047,
          83219,
          387843,
          8995,
          9073,
          8997
        ]
      },
      {
        "key": "成都",
        "id": "2301",
        "value": [
          53360,
          26237,
          19866,
          386044,
          44732,
          82251
        ]
      },
      {
        "key": "厦门",
        "id": "1401",
        "value": [
          11652,
          388340,
          402286,
          27684,
          209980,
          11601
        ]
      }
    ]
  },
  {
    "key": "海外热门目的地",
    "from": 0,
    "type": 0,
    "value": [
      {
        "key": "曼谷",
        "id":"EAN_178236",
        "value": [
          5032083,
          5029317,
          5018896,
          5021344,
          5024122,
          5037802
        ]
      },
      {
        "key": "普吉",
        "id":"EAN_6046393",
        "value": [
          5016029,
          5024412,
          5087641,
          5030373,
          5064498,
          5027662
        ]
      },
      {
        "key": "清迈",
        "id":"EAN_6056197",
        "value": [
          5065890,
          5038774,
          5013017,
          5037241,
          5165196
        ]
      },
      {
        "key": "吉隆坡",
        "id":"EAN_180008",
        "value": [
          5200964,
          5031212,
          5035777,
          5019291
        ]
      },
      {
        "key": "甲米",
        "id":"EAN_602231",
        "value": [
          5037419,
          5036119,
          5062515,
          5031634,
          5059827
        ]
      },
      {
        "key": "华欣",
        "id":"EAN_602231",
        "value": [
          5035319,
          5034725,
          5019352,
          5064206
        ]
      },
      {
        "key": "芭提雅",
        "id":"EAN_9514",
        "value": [
          5109713,
          5042924,
          5105919,
          5175954,
          5029538
        ]
      },
      {
        "key": "巴厘岛",
        "id":"EAN_602651",
        "value": [
          5152698,
          5110376,
          5200967,
          5147944,
          5043037
        ]
      },
      {
        "key": "首尔",
        "id":"EAN_178308",
        "value": [
          5102302,
          5035196,
          5025879,
          5024147,
          5030099
        ]
      },
      {
        "key": "苏梅岛",
        "id":"EAN_3657",
        "value": [
          5200959,
          5036673,
          5034209,
          5031195,
          5200960
        ]
      }
    ]
  }
]


module.exports = {
  list:list
} 


// WEBPACK FOOTER //
// ./src/components/common/HomeHotCityHotels.js